import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";
import { RiGridFill, RiListUnordered } from "react-icons/ri";
import { FiUser, FiSearch, FiX } from "react-icons/fi";
import BillingViewFilters from "../../BillingFilterJSON";
import DefaultPatientFilters from "../ClinicComponent/Filters/DefaultPatientFilters";
import PharmacyTableOrders from "./PharmacyTables/PharmacyTableOrders";
import { Offcanvas } from "react-bootstrap";
import StockComponentTable from "./StockComponentTable";
import AddBatchForm from "./AddBatchForm";


function StockComponentScreen() {
  const [activeView, setActiveView] = useState("list");
  const [patientDetail, setPatientDetail] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [hasData, setHasData] = useState(true);
 const [showAddPharmacy, setShowAddPharmacy] = useState(false);
const [editMode, setEditMode] = useState(false);
const [editBatchData, setEditBatchData] = useState(null);

  const handleAddNewItem = () => {
    setShowAddPharmacy(true); // 👈 open offcanvas instead of navigating
  };
  const handleEditItem = (batchData) => {
  setEditBatchData(batchData);
  setEditMode(true);
  setShowAddPharmacy(true); // open Offcanvas
};

const handleClose = () => {
  setShowAddPharmacy(false);
  setEditMode(false);
  setEditBatchData(null);
};

  const [patients, setPatients] = useState([]);



  const navigate = useNavigate();


  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  const handleSearch = () => {
    let searchValue = patientDetail.trim();

    if (!searchValue) {
      // Clear filters if search empty
      setSelectedFilters((prev) => {
        const { fullName, patientIDUniqueID, ...rest } = prev;
        return rest;
      });
      return;
    }

    let newFilter;

    if (/^PLCRXPAT\d+$/i.test(searchValue)) {
      // Already formatted Patient ID
      newFilter = {
        patientIDUniqueID: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    } else if (/^\d+$/.test(searchValue)) {
      // Only numbers → prepend prefix
      const prefixedValue = `PLCRXPAT${searchValue}`;
      newFilter = {
        patientIDUniqueID: {
          values: new Set([prefixedValue]),
          operator: "Contains",
        },
      };
    } else {
      // Otherwise treat as name
      newFilter = {
        fullName: {
          values: new Set([searchValue]),
          operator: "Contains",
        },
      };
    }

    setSelectedFilters((prev) => {
      const { fullName, patientIDUniqueID, ...rest } = prev;
      return { ...rest, ...newFilter };
    });
  };

const handleClearSearch = () => {
  setPatientDetail("");
  setSelectedFilters((prev) => {
    const { fullName, patientIDUniqueID, ...rest } = prev;
    return rest;
  });
  setHasData(true);
};



  return (
    <>
      <main style={{ width: "100%", height: "100%" }}>
        <div className="row">
          <div
            className="col-12 mb-4 d-flex justify-content-between align-items-center"
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}
          >
            <div>
              <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Stock</h2>
              {/* <p className="text-secondary">
                Register and manage patient records efficiently.
              </p> */}
            </div>
            <div className="d-flex align-items-center gap-3">
              <label className="relative">
                <input
                  type="text"
                  className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                  placeholder="Enter patient name or ID"
                  value={patientDetail}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPatientDetail(value);

                    if (value.trim() === "") {
                      setSelectedFilters((prev) => {
                        const { fullName, patientIDUniqueID, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                {patientDetail && (
                  <span
                    className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <FiX size={16} />
                  </span>
                )}
                <span
                  className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                  onClick={handleSearch}
                >
                  <FiSearch size={16} />
                </span>
              </label>

              

              <Whisper
                placement="top"
                trigger="hover"
                speaker={<Tooltip>Filter Options</Tooltip>}
              >
                <DefaultPatientFilters
                  defaultFilters={BillingViewFilters.stockFilters}
                  additionalFilters={BillingViewFilters.additionalStock}
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  setHasData={setHasData}
                />
              </Whisper>
              
             <div style={{ padding: 10, fontSize: "12px", display: "flex", justifyContent: "flex-end" }}>
      <button className="gradient-button" onClick={handleAddNewItem}>
        + Add New Item
      </button>
    </div>
    {/* ---------- Offcanvas for AddPharmacy ---------- */}
  <Offcanvas
  show={showAddPharmacy}
  onHide={handleClose}
  placement="end"
  backdrop="static"
  style={{ width: "50%" }}
>
  {/* Use a custom div inside Offcanvas.Header for better layout control */}
  <Offcanvas.Header
    closeButton
    style={{ borderBottom: "1px solid #eee", paddingRight: "1rem" ,padding: "10px 20px"}}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // ensures left/right split
        width: "100%", // makes sure it spans full width
      }}
    >
      {/* ---------- Left Side: Title + Subtitle ---------- */}
      <div>
        <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
  {editMode ? "Edit Batch" : "Add New Batch"}
</h3>
<span style={{ fontSize: "13px", color: "#888" }}>
  {editMode ? "Update batch details below" : "Add or Edit Stock Batches"}
</span>

      </div>

      {/* ---------- Right Side: Save Button ---------- */}

    </div>
  </Offcanvas.Header>

  <Offcanvas.Body style={{ padding: "10px 20px" }}>
   <AddBatchForm
  editData={editBatchData}
  isEditMode={editMode}
onHide={handleClose} />

  </Offcanvas.Body>
</Offcanvas>

    

              <div className="flex rounded-md overflow-hidden shadow-sm border border-gray-200 ml-[5px] w-fit">
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={<Tooltip>List view</Tooltip>}
                >
                  <button
                    onClick={() => setActiveView("list")}
                    className={getButtonClasses("list")}
                  >
                    <RiListUnordered size={20} />
                  </button>
                </Whisper>
                
              </div>
            </div>
          </div>
        </div>   

        {activeView === "list" && (<StockComponentTable
  hasData={true}
  setHasData={setHasData}
  onEdit={handleEditItem}
   onAddNew={handleAddNewItem}   
/>

        )}
      </main>
    </>
  );
}

export default StockComponentScreen;
